import type { CustomIconProps } from '../CustomIcon';

export const LogoutIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6' fill={color} />
      <path
        d='M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6M16 17l5-5-5-5M21 12H9'
        stroke={secondaryColor}
        strokeWidth={1.5}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
